import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from ".";
import type { DictationLessonDetail } from "@/models/dictation-lesson-detail";

interface DictationState {
  courseDictationLessonDetail: DictationLessonDetail | null;
}

const initialState: DictationState = {
  courseDictationLessonDetail: null,
};

export const dictationSlice = createSlice({
  name: "dictation",
  initialState,
  reducers: {
    setCourseDictationLessonDetail: (
      state,
      action: PayloadAction<DictationLessonDetail | null>,
    ) => {
      state.courseDictationLessonDetail = action.payload ?? null;
    },
    updateWordExistOnWordbook: (
      state,
      action: PayloadAction<{ wordText: string; existOnWordbook: boolean }>,
    ) => {
      const { wordText, existOnWordbook } = action.payload;

      // Update in courseDictationLessonDetail.relatedWords
      if (state.courseDictationLessonDetail?.relatedWords) {
        const wordIndex = state.courseDictationLessonDetail.relatedWords.findIndex(
          (w) => w.word === wordText,
        );
        if (wordIndex !== -1) {
          state.courseDictationLessonDetail.relatedWords[wordIndex].existOnWordbook =
            existOnWordbook;
        }
      }
    },
    updateSentenceExistOnPractice: (
      state,
      action: PayloadAction<{ sentenceId: string; existOnPractice: boolean }>,
    ) => {
      const { sentenceId, existOnPractice } = action.payload;

      // Update in courseDictationLessonDetail.sentences
      if (state.courseDictationLessonDetail?.sentences) {
        const sentenceIndex = state.courseDictationLessonDetail.sentences.findIndex(
          (s) => s.sentenceId === sentenceId,
        );
        if (sentenceIndex !== -1) {
          state.courseDictationLessonDetail.sentences[sentenceIndex].existOnPractice =
            existOnPractice;
        }
      }
    },
    resetState: (state) => {
      state.courseDictationLessonDetail = null;
    },
  },
});

export const {
  setCourseDictationLessonDetail,
  updateWordExistOnWordbook,
  updateSentenceExistOnPractice,
  resetState,
} = dictationSlice.actions;

export const getCourseDictationLessonDetail = (state: RootState) =>
  state.dictation.courseDictationLessonDetail;

export default dictationSlice.reducer;
